/* tslint:disable:max-line-length semicolon *//*
 * (c) Copyright 2018 e5 Workflow
 *
 * Angular module for e5 Anywhere API generated 2/6/2019, 5:37:18 PM.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as e5services from './services/e5.data.services';

import { HttpClientModule } from '@angular/common/http';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule
    ],
    declarations: [],
    providers: [
      e5services.ConfigurationInstanceService,
      e5services.ConfigurationScopeService,
      e5services.ConfigurationSectionService,
      e5services.ConfigurationSettingService,
      e5services.IdentityClaimService,
      e5services.IdentityUserProfileService,
      e5services.IdentityUserSessionService,
      e5services.IntegrationSiteService,
      e5services.IntegrationYammerMessagesService,
      e5services.IntegrationYammerTopicsService,
      e5services.ListSearchService,
      e5services.MonitorsSlaCompletionMonitorService,
      e5services.MonitorsSlaInflowsMonitorService,
      e5services.MonitorsSlaInventoryMonitorService,
      e5services.MonitorsSlaMonitorService,
      e5services.MonitorsSlaTeamProductivityCompletionMonitorService,
      e5services.MonitorsSlaTeamProductivityFacetimeMonitorService,
      e5services.TaxonomyActivityDefinitionCheckService,
      e5services.TaxonomyActivityDefinitionContentTypeService,
      e5services.TaxonomyActivityDefinitionProcessService,
      e5services.TaxonomyAdapterService,
      e5services.TaxonomyAttachmentTypeService,
      e5services.TaxonomyAttachmentTypeRoleService,
      e5services.TaxonomyCaseNoteTypeService,
      e5services.TaxonomyCategory1Service,
      e5services.TaxonomyCategory2Service,
      e5services.TaxonomyCategory3Service,
      e5services.TaxonomyCategoryActivityAttributeService,
      e5services.TaxonomyCategoryActivityDefinitionService,
      e5services.TaxonomyCategoryActivityFieldService,
      e5services.TaxonomyCategoryActivityRoleService,
      e5services.TaxonomyCategoryAttachmentTypeService,
      e5services.TaxonomyCategorySiteService,
      e5services.TaxonomyContentTypeCustomService,
      e5services.TaxonomyContentTypeFieldSetService,
      e5services.TaxonomyContentTypeGridService,
      e5services.TaxonomyCurrencyService,
      e5services.TaxonomyEventService,
      e5services.TaxonomyFieldDefinitionService,
      e5services.TaxonomyFieldDefinitionCaseNoteService,
      e5services.TaxonomyFieldDefinitionCurrencyService,
      e5services.TaxonomyFieldDefinitionLinkService,
      e5services.TaxonomyFieldDefinitionListService,
      e5services.TaxonomyFieldDefinitionLookupService,
      e5services.TaxonomyFieldDefinitionSimpleService,
      e5services.TaxonomyFieldFoundationService,
      e5services.TaxonomyLibraryService,
      e5services.TaxonomyListService,
      e5services.TaxonomyListItemService,
      e5services.TaxonomyLocationService,
      e5services.TaxonomyLookupService,
      e5services.TaxonomyMenuService,
      e5services.TaxonomyMenuItemDefinitionService,
      e5services.TaxonomyPriorityService,
      e5services.TaxonomyPublicHolidayService,
      e5services.TaxonomyRoleService,
      e5services.TaxonomyStatusService,
      e5services.UiAttachmentService,
      e5services.UiDocumentService,
      e5services.UiSearchDefinitionService,
      e5services.UiWorkItemService,
      e5services.WorkAttachmentFoundationService,
      e5services.WorkAttachmentTypeFoundationService,
      e5services.WorkCaseNoteFoundationService,
      e5services.WorkConversationFoundationService,
      e5services.WorkDocumentFoundationService,
      e5services.WorkFieldFoundationService,
      e5services.WorkFieldSetFoundationService,
      e5services.WorkGetNextService,
      e5services.WorkItemService,
      e5services.WorkItemFoundationService,
      e5services.WorkMenuItemFoundationService,
      e5services.WorkPropertyFoundationService,
      e5services.WorkSearchFoundationService,
      e5services.WorkTaskFoundationService,

    ]
})
export class E5coreAngularServicesModule { }
